export enum RoleEnum {
  Admin = 1,
  Initiator = 2,
  RnDHead = 3,
  RnDManager = 4,
  TaskOwner = 5,
  QualityAssurance = 6,
}
